import { render, staticRenderFns } from "./scroll_top.vue?vue&type=template&id=19df47fc&"
import script from "./scroll_top.vue?vue&type=script&lang=js&"
export * from "./scroll_top.vue?vue&type=script&lang=js&"
import style0 from "./scroll_top.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports